<template>
  <div class="wrapper">
    <div class="main-content d-none d-sm-none d-md-block" data="vue">
      <nav
        class="navbar navbar-expand-md navbar-top navbar-dark"
        id="navbar-main"
      >
        <div class="container-fluid">
          <div class="collapse navbar-collapse" id="0.7516493789564676">
            <a href="/" class="active navbar-brand"
              ><img
                src="/img/logo-pardis.png"
                class="navbar-brand-img"
                alt="..."
            /></a>
            <ul class="club-top-menu">
              <li>
                <router-link to="/" class="submenu-text submenu-special">
                  رزرو آنلاین خدمات
                </router-link>
              </li>
            </ul>
            <ul
              _ngcontent-c3=""
              class="navbar-nav align-items-center d-none d-md-flex"
            >
              <li
                _ngcontent-c3=""
                class="nav-item show dropdown"
                ngbdropdown=""
                placement="bottom-right"
              >
                <a
                  _ngcontent-c3=""
                  aria-haspopup="true"
                  class="nav-link pr-0 dropdown-toggle"
                  ngbdropdowntoggle=""
                  role="button"
                  aria-expanded="true"
                  ><div _ngcontent-c3="" class="media align-items-center">
                    <span
                      _ngcontent-c3=""
                      class="avatar avatar-sm rounded-circle"
                    >
                      <div class="profile-se">
                        <i class="ni ni-circle-08"></i>
                      </div>
                    </span>
                    <div
                      _ngcontent-c3=""
                      class="media-body ml-2 d-none d-lg-block"
                    >
                      <span
                        _ngcontent-c3=""
                        class="mb-0 text-sm font-weight-bold"
                      >
                        {{ GetUsername }}</span
                      >
                      <br />
                      <span _ngcontent-c3="">
                        امتیاز شما : {{ GetCustomerScore | numFormat }}
                      </span>
                    </div>
                  </div></a
                >
                <div
                  _ngcontent-c3=""
                  class="dropdown-menu-arrow dropdown-menu-right dropdown-menu"
                  ngbdropdownmenu=""
                  x-placement="bottom-right"
                >
                  <div _ngcontent-c3="" class="dropdown-header noti-title">
                    <h6 _ngcontent-c3="" class="text-overflow m-0">
                      خوش آمدید!
                    </h6>
                  </div>
                  <div
                    _ngcontent-c3=""
                    class="dropdown-item"
                    routerlinkactive="active"
                    href="#/user-profile"
                  >
                    <i _ngcontent-c3="" class="icon-money-1"></i
                    ><span _ngcontent-c3="">
                      اعتبار شما : {{ GetSumDeposit | numFormat }}</span
                    >
                  </div>
                  <div
                    _ngcontent-c3=""
                    class="dropdown-item"
                    routerlinkactive="active"
                    href="#/user-profile"
                  >
                    <i _ngcontent-c3="" class="icon-award"></i
                    ><span _ngcontent-c3="">
                      امتیاز شما : {{ GetCustomerScore | numFormat }}</span
                    >
                  </div>
                  <div
                    _ngcontent-c3=""
                    class="dropdown-item"
                    routerlinkactive="active"
                    href="#/user-profile"
                  >
                    <i _ngcontent-c3="" class="icon-money-2"></i
                    ><span _ngcontent-c3="">
                      اعتبار ریالی :
                      {{ GetCustomerValueAmount | numFormat }}</span
                    >
                  </div>
                  <!-- <router-link
                    to="/profile/dashboard"
                    v-if="this.$route.fullPath.includes('club')"
                    class="dropdown-item"
                    ><i _ngcontent-c3="" class="ni ni-single-02"></i
                    ><span _ngcontent-c3=""> پروفایل </span>
                  </router-link>

                  <router-link
                    to="/club/dashboard"
                    v-if="this.$route.fullPath.includes('profile')"
                    class="dropdown-item"
                    ><i _ngcontent-c3="" class="ni ni-single-02"></i
                    ><span _ngcontent-c3="">باشگاه مشتریان </span>
                  </router-link> -->

                  <div _ngcontent-c3="" class="dropdown-divider"></div>
                  <a _ngcontent-c3="" class="dropdown-item" @click="SignOut()"
                    ><i _ngcontent-c3="" class="ni ni-user-run"></i
                    ><span _ngcontent-c3="">خروج</span></a
                  >
                </div>
              </li>
            </ul>
          </div>

          <a
            aria-current="page"
            href="#/dashboard"
            class="
              active
              router-link-exact-active
              h4
              mb-0
              text-white text-uppercase
              d-none d-lg-inline-block
            "
          ></a
          ><!---->
        </div>
      </nav>
    </div>
    <IntroductionClubModal
      v-if="isShowModal && !IsSeenIntroduction"
      @closeModal="closeModal"
    />
  </div>
</template>
<script>
import store from "@/views/profile/store/index";
import IntroductionClubModal from "../../components/club/IntroductionClubModal";

var qs = require("qs");

export default {
  store,
  data() {
    return {
      topline: [],
      isShowModal: false,
    };
  },
  components: { IntroductionClubModal },
  computed: {
    GetUsername() {
      return localStorage.getItem("Username");
    },
    GetSumDeposit() {
      if (localStorage.getItem("SourceIdInReport") != null)
        return this.$store.getters.GetSumDeposit;
      else return 0;
    },
    GetCustomerScore() {
      return this.$store.getters.GetCustomerClubData.score;
    },
    GetCustomerValueAmount() {
      return this.$store.getters.GetCustomerClubData.valueAmount;
    },
    IsSeenIntroduction() {
      return this.$store.getters.GetCustomerClubData.isSeenIntroduction;
    },
  },
  created() {
    this.checkForLogin();
    this.getUserId();
    this.checkSources();
  },

  mounted() {
    $(".dropdown .dropdown-toggle").hover(
      function () {
        $(".dropdown-menu-arrow").addClass("show");
      },
      function () {
        $(".dropdown-menu-arrow").removeClass("show");
      }
    );
    $(".dropdown-menu-arrow").hover(
      function () {
        $(this).addClass("show");
      },
      function () {
        $(this).removeClass("show");
      }
    );
  },
  methods: {
    closeModal() {
      this.isShowModal = false;
    },
    checkForLogin() {
      this.$store.dispatch("checkForLogin");
    },
    SignOut() {
      this.$store.dispatch("signOut").then(() => {
        if (this.$route.name != "main home") this.$router.push("/");
      });
      // this.$store.dispatch("fillCheckMenuList", false);
    },
    async getUserId() {
      this.userId = this.$store.getters.GetUserId;
    },
    async checkSources() {
      const isAuthenticated = this.$store.getters.IsUserAuthenticated;
      if (isAuthenticated) {
        this.sources = this.$store.getters.GetAllSourceConfirmed;
        this.customerClubData = this.$store.getters.GetCustomerClubData;

        if (this.sources.length == 0) {
          this.getAllSource();
        }

        if (Object.keys(this.customerClubData).length === 0) {
          this.getCustomerDataByBusiness();
        } else {
          this.isShowModal = true;
          localStorage.setItem("IntroductionModalCount", 0);
        }
      }
    },

    async getAllSource() {
      this.$store.dispatch("getAllSourceConfirmed", this.userId).then((res) => {
        this.sources = res;
        // setDefulatSource
        if (this.sources != null) {
          this.$store.dispatch("getDepositInCrs", this.sources[0].id);
        }
      });
    },
    async getCustomerDataByBusiness() {
      const res = await this.$store.dispatch(
        "getProfileByProfileId",
        localStorage.getItem("UserId")
      );
      if (res.data !== "") {
        if (
          res.data.profileId != "00000000-0000-0000-0000-000000000000" &&
          parseInt(localStorage.getItem("IntroductionModalCount")) === 1
        )
          this.isShowModal = true;
        localStorage.setItem("IntroductionModalCount", 0);
      }
    },
  },
};
</script>

<style scoped>
.profile-se {
  margin-top: 17px;
}
.profile-se span {
  font-size: 16px;
  font-weight: 500;
  margin-right: 5px;
  color: #444;
}
.club-top-menu {
  display: flex;
}
.club-top-menu li {
  list-style: none;
  margin: 0 20px;
}
.club-top-menu li a {
  font-weight: 500 !important;
  font-size: 18px;
  color: #444;
}
.club-top-menu li .submenu-special {
  background: #0c3883;
  padding: 8px 30px 10px;
  border-radius: 33px;
  line-height: 30px;
  color: #fff;
  -webkit-animation: heartbeatt 3s ease-in-out 7s infinite;
  animation: heartbeatt 3s ease-in-out 7s infinite;
}
@-webkit-keyframes heartbeatt {
  0% {
    -webkit-transform: scale(1);
    transform: scale(1);
    -webkit-transform-origin: center center;
    transform-origin: center center;
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out;
  }

  17% {
    -webkit-transform: scale(0.98);
    transform: scale(0.98);
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out;
  }

  45% {
    -webkit-transform: scale(1);
    transform: scale(1);
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out;
  }
}
@keyframes heartbeatt {
  0% {
    -webkit-transform: scale(1);
    transform: scale(1);
    -webkit-transform-origin: center center;
    transform-origin: center center;
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out;
  }

  17% {
    -webkit-transform: scale(0.98);
    transform: scale(0.98);
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out;
  }

  45% {
    -webkit-transform: scale(1);
    transform: scale(1);
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out;
  }
}
.modalMain {
  z-index: 9999;
}
</style>
<style src="../../../public/css/subStyle.css"></style>